module.exports = __webpack_public_path__ + "static/img/flexible-bg-ipad.4785ef85.png";